import React, { useEffect, useState, useContext } from "react";
import OwnerHeader from "./Components/OwnerHeader";
import {
  Button,
  CircularProgress,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Divider,
  withStyles,
  Switch,
  InputLabel,
  FormControl,
  Select,
  Input,
  MenuItem,
  InputAdornment,
  Tabs,
  Tab,
  Tooltip,
} from "@material-ui/core";
import axios from "axios";
import { imageUrl, Instance } from "../../Config";
import useSWR from "swr";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  INIT_OWNER,
  INIT_SETTINGS,
  SHOW_SNACKBAR,
} from "../../Context/globalActions.types";
import GlobalContext from "../../Context/globalContext";
import CompanyLogoDialog from "./Components/CompanyLogoDialog";
import { resizeImg } from "../../utils/resizeImg";
import StorefrontIcon from "@material-ui/icons/Storefront";
import ViewCarouselOutlinedIcon from "@material-ui/icons/ViewCarouselOutlined";
import StorefrontOutlinedIcon from "@material-ui/icons/StorefrontOutlined";
import CropFreeOutlinedIcon from "@material-ui/icons/CropFreeOutlined";
import BurstModeOutlinedIcon from "@material-ui/icons/BurstModeOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import ColorLensOutlinedIcon from "@material-ui/icons/ColorLensOutlined";
import FacebookIcon from "@material-ui/icons/Facebook";
import YouTubeIcon from "@material-ui/icons/YouTube";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import { useSWRConfig } from "swr";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import ShareIcon from "@material-ui/icons/Share";
import { Skeleton } from "@material-ui/lab";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ShopClosure from "./ShopClosure";
var QRCode = require("qrcode.react");

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
      className="min-h-screen bg-[#F1F5F9]"
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: "#ffffff",
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const OwnerUtility = () => {
  const [isUploading, setIsUploading] = useState({
    isPaymentImgUploading: false,
    isLogoImgUploading: false,
    isBannerUploading: false,
    isBulkUploading: false,
    isSettingsLoading: false,
    isThemeLoading: false,
    isSocialLinkLoading: false,
    isConfigSettingsLoading: false,
    isUpdateLabelsLoading: false,
  });
  const params = useParams();
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [imageError, setImageError] = useState(false);

  const [tabValue, setTabValue] = useState(0);

  const { mutate } = useSWRConfig();

  const history = useHistory();

  const [isSync, setIsSync] = useState(false);
  const [dataNm, setDataNm] = useState("");

  const { data: resCompany, error: resCompanyError } = useSWR(
    `/saral/company?mobileNo=${params.mobileNo}`,
  );

  const [settings, setSettings] = useState([]);
  const [theme, setTheme] = useState({
    primaryColor: "#000000",
    primaryColorText: "#000000",
    secondaryColor: "#000000",
    secondaryColorText: "#000000",
  });

  const [socialLink, setSocialLink] = useState({
    FBLINK: null,
    IGLINK: null,
    YTLINK: null,
    WHANO: null,
  });

  const [configSettings, setConfigSettings] = useState({
    orderNo: "",
    partyGd: "",
    salesmanGd: "",
    authTTL: "",
  });

  const { globalContext, dispatch } = useContext(GlobalContext);
  const [localImg, setLocalImg] = useState([]);

  const [bulkImgCompleted, setBulkImgCompleted] = useState([]);

  const [updateLabels, setUpdateLabels] = useState({
    advancePaymentField: {
      label: "",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    checkoutRemarks1: {
      label: "",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    checkoutRemarks2: {
      label: "",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    checkoutRemarks3: {
      label: "",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupName: {
      label: "Name",
      isRequired: true,
      type: "text",
      isVisible: true,
    },
    signupCompanyName: {
      label: "Company Name",
      isRequired: true,
      type: "text",
      isVisible: true,
    },
    signupPassword: {
      label: "Password",
      isRequired: true,
      type: "password",
      isVisible: true,
    },
    signupPhone: {
      label: "Phone Number",
      isRequired: true,
      type: "text",
      isVisible: true,
    },
    signupPan: {
      label: "PAN",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupGst: {
      label: "GST",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupAddress1: {
      label: "Address 1",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupAddress2: {
      label: "Address 2",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupCity: {
      label: "City",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupState: {
      label: "State",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupDistrict: {
      label: "District",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupPincode: {
      label: "Pincode",
      isRequired: false,
      type: "text",
      isVisible: false,
    },
    signupEmail: {
      label: "Email",
      isRequired: false,
      type: "email",
      isVisible: false,
    },
  });

  const sendImage = (image, width, height) => {
    return new Promise((resolve) => {
      Instance.post("/uploads/signUrl", {
        fileType: image.type,
      })
        .then(async (res) => {
          const img = width
            ? await resizeImg(image, image.type.split("/")[1], width, height)
            : await resizeImg(image, image.type.split("/")[1]);
          axios
            .put(res.data.result, img, {
              headers: {
                "Content-Type": image.type,
                "x-amz-acl": "public-read",
              },
            })
            .then(() => {
              resolve(res.data.fileName);
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch((err) => {
          console.log(err.data);
        });
    });
  };

  const uploadImage = async (uploadData, width, height) => {
    let imgArry = [];
    for (const image of uploadData) {
      const data = await sendImage(image, width, height);
      imgArry.push(data);
    }
    return imgArry;
  };

  const deleteImage = async (id) => {
    await Instance.delete(`/uploads/${id}`);
  };

  const { data: resOwnerDetail, error: resOwnerDetailError } = useSWR(
    `/owner?mobileNo=${params.mobileNo}`,
  );

  const { data: resOwnerSettings, error: resOwnerSettingsError } = useSWR(
    `/settings?mobileNo=${params.mobileNo}`,
  );

  const { data: resSpsFileSettings, error: resSpsFileSettingsError } = useSWR(
    `/spsfile?mobileNo=${params.mobileNo}`,
  );

  const { data: resUpdateLabels, error: resUpdateLabelsError } = useSWR(
    `/labels?mobileNo=${params.mobileNo}`,
  );

  useEffect(() => {
    if (resSpsFileSettings) {
      setDataNm(
        resSpsFileSettings.data.result.find((e) => e.VARIABLE == "dataNm")
          ? resSpsFileSettings.data.result.find((e) => e.VARIABLE == "dataNm")
              .VALUE
          : "",
      );
      setConfigSettings({
        orderNo: resSpsFileSettings.data.result.find(
          (e) => e.VARIABLE == "orderNo",
        )
          ? resSpsFileSettings.data.result.find((e) => e.VARIABLE == "orderNo")
              .VALUE
          : "",
        partyGd: resSpsFileSettings.data.result.find(
          (e) => e.VARIABLE == "partyGd",
        )
          ? resSpsFileSettings.data.result.find((e) => e.VARIABLE == "partyGd")
              .VALUE
          : "",
        salesmanGd: resSpsFileSettings.data.result.find(
          (e) => e.VARIABLE == "salesmanGd",
        )
          ? resSpsFileSettings.data.result.find(
              (e) => e.VARIABLE == "salesmanGd",
            ).VALUE
          : "",

        authTTL: resSpsFileSettings.data.result.find(
          (e) => e.VARIABLE == "authTTL",
        )
          ? resSpsFileSettings.data.result.find((e) => e.VARIABLE == "authTTL")
              .VALUE
          : "",
        maxImages: resSpsFileSettings.data.result.find(
          (e) => e.VARIABLE == "maxImages",
        )
          ? resSpsFileSettings.data.result.find(
              (e) => e.VARIABLE == "maxImages",
            ).VALUE
          : "4",
        maxVideos: resSpsFileSettings.data.result.find(
          (e) => e.VARIABLE == "maxVideos",
        )
          ? resSpsFileSettings.data.result.find(
              (e) => e.VARIABLE == "maxVideos",
            ).VALUE
          : "0",
      });
    }
  }, [resSpsFileSettings]);

  useEffect(() => {
    if (resOwnerSettings) {
      dispatch({
        type: INIT_SETTINGS,
        payload: resOwnerSettings.data.result,
      });
      let temp = [];
      for (let i = 0; i < resOwnerSettings.data.result.length; i++) {
        if (resOwnerSettings.data.result[i].VALUE == "Y") {
          temp.push(resOwnerSettings.data.result[i].VARIABLE);
        }
      }
      setSettings(temp);
    }
  }, [resOwnerSettings]);

  useEffect(() => {
    if (resUpdateLabels) {
      let temp = {};
      for (let i = 0; i < resUpdateLabels.data.result.length; i++) {
        temp = {
          ...temp,
          [resUpdateLabels.data.result[i].SETTINGS_VARIABLE]: {
            isRequired: resUpdateLabels.data.result[i].IS_REQUIRED,
            label: resUpdateLabels.data.result[i].LABEL,
            type: resUpdateLabels.data.result[i].FIELD_TYPE,
            isVisible: resUpdateLabels.data.result[i].IS_VISIBLE,
          },
        };
      }
      setUpdateLabels(temp);
    }
  }, [resUpdateLabels]);

  useEffect(() => {
    if (
      resOwnerSettingsError ||
      resOwnerDetailError ||
      resSpsFileSettingsError ||
      resUpdateLabelsError
    ) {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          message: "Something Went Wrong",
          type: "error",
        },
      });
    }
  }, [
    resOwnerSettingsError,
    resOwnerDetailError,
    resSpsFileSettingsError,
    resUpdateLabelsError,
  ]);

  useEffect(() => {
    if (
      resOwnerDetail &&
      resOwnerDetail.data.result &&
      resOwnerDetail.data.result.length > 0
    ) {
      if (resOwnerDetail.data.result[0].COLOR) {
        setTheme({
          primaryColor: resOwnerDetail.data.result[0].COLOR.primaryColor,
          secondaryColor: resOwnerDetail.data.result[0].COLOR.secondaryColor,
          primaryColorText:
            resOwnerDetail.data.result[0].COLOR.primaryColorText,
          secondaryColorText:
            resOwnerDetail.data.result[0].COLOR.secondaryColorText,
        });
      }

      setSocialLink({
        FBLINK: resOwnerDetail.data.result[0].FBLINK,
        IGLINK: resOwnerDetail.data.result[0].IGLINK,
        YTLINK: resOwnerDetail.data.result[0].YTLINK,
        WHANO: resOwnerDetail.data.result[0].WHANO,
      });

      if (resOwnerDetail.data.result[0].BANNER) {
        setLocalImg(resOwnerDetail.data.result[0].BANNER);
      } else {
        setLocalImg([]);
      }
      dispatch({
        payload: resOwnerDetail.data.result,
        type: INIT_OWNER,
      });
    }
  }, [resOwnerDetail]);

  const location = useLocation();
  function getQueryVariable(variable) {
    var query = location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
  }

  useEffect(() => {
    setTabValue(
      Number(getQueryVariable("tab") ? getQueryVariable("tab") : "0"),
    );
  }, []);

  // Reset to tab 0 if on Shop Availability tab but setting is disabled
  useEffect(() => {
    if (tabValue === 3 && !settings.includes("shopClosureEnabled")) {
      setTabValue(0);
    }
  }, [settings]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen1 = () => {
    setOpen1(true);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };

  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const isShopClosureEnabled = settings.includes("shopClosureEnabled");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  const handleBulkUpload = (images) => {
    function pad(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    }
    const imagesArray = Array.from(images);

    Instance.get("/products/categoryId")
      .then(async (res) => {
        for (
          let i = 1;
          i <= parseInt(res.data.result[0].DEPT_CD.split("E")[1], 10);
          i++
        ) {
          // CATG_1_CODE.jpg
          const categoryCd = `E${pad(i, 3)}`;
          const file = imagesArray.filter(
            (e) => e.name.split("_")[2].split(".")[0] == categoryCd,
          );
          if (file.length != 0 && file.length <= 4) {
            const imgUrls = await uploadImage(file, 625, 800);
            Instance.post("/products/bulk", {
              mobileNo: params.mobileNo,
              imgUrl: imgUrls,
              code: categoryCd,
            });
            setBulkImgCompleted(categoryCd);
          }
          if (i == parseInt(res.data.result[0].DEPT_CD.split("E")[1], 10)) {
            Instance.get("/products/productId")
              .then(async (res) => {
                for (
                  let i = 1;
                  i <= parseInt(res.data.result[0].ITEM_CD.split("I")[1], 10);
                  i++
                ) {
                  const itemCd = `I${pad(i, 7)}`;
                  const file = imagesArray.filter(
                    (e) => e.name.split("_")[2].split(".")[0] == itemCd,
                  );
                  if (file.length != 0 && file.length <= 4) {
                    const imgUrls = await uploadImage(file, 625, 800);
                    Instance.post("/products/bulk", {
                      mobileNo: params.mobileNo,
                      imgUrl: imgUrls,
                      code: itemCd,
                    });
                    setBulkImgCompleted(itemCd);
                  }
                  if (
                    i == parseInt(res.data.result[0].ITEM_CD.split("I")[1], 10)
                  ) {
                    setIsUploading({
                      ...isUploading,
                      isBulkUploading: false,
                    });
                  }
                }
              })
              .catch(() => {
                dispatch({
                  type: SHOW_SNACKBAR,
                  payload: {
                    message: "Something Went Wrong",
                    type: "error",
                  },
                });
              });
          }
        }
      })
      .catch(() => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something Went Wrong",
            type: "error",
          },
        });
      });
  };

  const handleSettingsSubmit = (e) => {
    e.preventDefault();
    setIsUploading({ ...isUploading, isSettingsLoading: true });
    Instance.put("/settings", {
      mobileNo: params.mobileNo,
      settings: settings,
    })
      .then((res) => {
        mutate(`/settings?mobileNo=${params.mobileNo}`);
        mutate(`/labels?mobileNo=${params.mobileNo}`);
        setIsUploading({ ...isUploading, isSettingsLoading: false });
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Settings has been updated successfully",
            type: "success",
          },
        });
      })
      .catch(() => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something Went Wrong",
            type: "error",
          },
        });
      });
  };

  const handleThemeSubmit = (e) => {
    e.preventDefault();
    setIsUploading({ ...isUploading, isThemeLoading: true });
    Instance.put("/owner", {
      type: "color",
      data: theme,
      mobileNo: params.mobileNo,
    })
      .then((res) => {
        if (res.status == 200) {
          setIsUploading({ ...isUploading, isThemeLoading: false });
          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: "Theme has been updated successfully",
              type: "success",
            },
          });
        }
      })
      .catch(() => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something Went Wrong",
            type: "error",
          },
        });
      });
  };

  const handleSocialLinkSubmit = (e) => {
    e.preventDefault();
    setIsUploading({ ...isUploading, isSocialLinkLoading: true });
    Instance.put("/owner", {
      type: "socialLinks",
      data: socialLink,
      mobileNo: params.mobileNo,
    })
      .then((res) => {
        if (res.status == 200) {
          setIsUploading({ ...isUploading, isSocialLinkLoading: false });
          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: "Social Links has been updated successfully",
              type: "success",
            },
          });
        }
      })
      .catch(() => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something Went Wrong",
            type: "error",
          },
        });
      });
  };

  const handleLabelsSubmit = (e) => {
    e.preventDefault();
    setIsUploading({ ...isUploading, isUpdateLabelsLoading: true });
    Instance.put("/labels", {
      labels: updateLabels,
      mobileNo: params.mobileNo,
    })
      .then((res) => {
        if (res.status == 200) {
          setIsUploading({ ...isUploading, isUpdateLabelsLoading: false });
          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: "Labels has been updated successfully",
              type: "success",
            },
          });
        }
      })
      .catch(() => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something Went Wrong",
            type: "error",
          },
        });
      });
  };

  const handleSyncBtn = () => {
    setIsSync(true);
    Instance.post("/sync", {
      mobileNo: params.mobileNo,
      dataNm: dataNm,
    })
      .then((res) => {
        if (res.status == 201) {
          setIsSync(false);
          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: "Data Sync successfully",
              type: "success",
            },
          });
        }
      })
      .catch((e) => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something went wrong. Please open the app again.",
            type: "error",
          },
        });
        setIsSync(false);
      });
  };

  const handleConfigSettingsBtn = (e) => {
    e.preventDefault();
    setIsUploading({ ...isUploading, isConfigSettingsLoading: true });
    Instance.put("/spsfile", {
      data: [
        {
          value: configSettings.orderNo,
          variable: "orderNo",
        },
        {
          value: configSettings.partyGd,
          variable: "partyGd",
        },
        {
          value: configSettings.salesmanGd,
          variable: "salesmanGd",
        },
        {
          value: configSettings.authTTL,
          variable: "authTTL",
        },
        {
          value: configSettings.maxImages,
          variable: "maxImages",
        },
        {
          value: configSettings.maxVideos,
          variable: "maxVideos",
        },
      ],
      mobileNo: params.mobileNo,
    })
      .then((res) => {
        if (res.status == 200) {
          setIsUploading({ ...isUploading, isConfigSettingsLoading: false });
          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: "Config Settings has been updated successfully",
              type: "success",
            },
          });
        }
      })
      .catch(() => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something Went Wrong",
            type: "error",
          },
        });
      });
  };

  return (
    <div>
      <OwnerHeader>
        <UploadForm
          deleteImage={deleteImage}
          dispatch={dispatch}
          globalContext={globalContext}
          handleClose={handleClose}
          imageError={imageError}
          isUploading={isUploading}
          localImg={localImg}
          open={open}
          params={params}
          setImageError={setImageError}
          setIsUploading={setIsUploading}
          setLocalImg={setLocalImg}
          uploadImage={uploadImage}
        />
        <CompanyLogoDialog handleClose={handleClose2} open={open2} />
        <BulkUploadForm
          bulkImgCompleted={bulkImgCompleted}
          handleBulkUpload={handleBulkUpload}
          handleClose1={handleClose1}
          isUploading={isUploading}
          open1={open1}
          setIsUploading={setIsUploading}
        />
        <div>
          <div className="md:flex items-center justify-between px-3 md:px-4 py-3">
            <div>
              <div className="text-indigo-500 font-semibold text-sm md:text-base">
                Settings
              </div>
              <div className="text-xl md:text-2xl font-extrabold leading-7 sm:leading-10 truncate mt-1">
                Utilities
              </div>
            </div>
          </div>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            className="ml-2 text-[#3333cc]"
            scrollButtons="auto"
            variant="scrollable"
            TabIndicatorProps={{ style: { background: "#3333cc" } }}
          >
            <Tab
              label="General"
              {...a11yProps(0)}
              onClick={() => {
                history.push(`/${params.mobileNo}/owner/utility?tab=0`);
              }}
            />
            <Tab
              label="Admin Settings"
              {...a11yProps(1)}
              onClick={() => {
                history.push(`/${params.mobileNo}/owner/utility?tab=1`);
              }}
            />
            <Tab
              label="Home Layout"
              {...a11yProps(2)}
              onClick={() => {
                history.push(`/${params.mobileNo}/owner/utility?tab=2`);
              }}
            />
            {isShopClosureEnabled && (
              <Tab
                label="Shop Availability"
                {...a11yProps(3)}
                onClick={() => {
                  history.push(`/${params.mobileNo}/owner/utility?tab=3`);
                }}
              />
            )}
          </Tabs>
        </div>

        <div className=" bg-[#F1F5F9] min-h-screen pt-3 px-3 pb-5">
          <TabPanel value={tabValue} index={0}>
            <div className="bg-white shadow-sm rounded p-3 ">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <ViewCarouselOutlinedIcon /> Sync Data
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className=" bg-[#3333cc] text-white"
                  onClick={handleSyncBtn}
                >
                  {isSync ? (
                    <CircularProgress
                      size={25}
                      className="hover:text-white text-black"
                    />
                  ) : (
                    "Sync"
                  )}
                </Button>
              </div>
              <Divider className="mt-2" />
              <div>
                <div className="flex flex-col md:flex-row items-center md:justify-between md:items-start mt-3">
                  {resCompany ? (
                    <FormControl className="md:w-52 w-full">
                      <InputLabel id="demo-mutiple-checkbox-label">
                        Please Select Company
                      </InputLabel>
                      <Select
                        labelId="demo-mutiple-checkbox-label"
                        id="demo-mutiple-checkbox"
                        value={dataNm}
                        onChange={(e) => {
                          setDataNm(e.target.value);
                        }}
                        input={<Input />}
                        className="w-72"
                      >
                        {resCompany.data.result.map((name) => (
                          <MenuItem
                            key={name.DATANM}
                            value={name.DATANM}
                            className="px-2"
                          >
                            <p className="text-xs mb-0">
                              {name.fromyr}-{name.toyr} ({name.DATANM}) (
                              {name.comp_name.length > 12
                                ? name.comp_name.split(0, 12) + "..."
                                : name.comp_name.split(0, 12)}
                              )
                            </p>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <Skeleton className="md:w-52 w-full" />
                  )}
                </div>
              </div>
            </div>
            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <ViewCarouselOutlinedIcon /> Upload Banner
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className=" bg-[#3333cc] text-white"
                  onClick={handleClickOpen}
                >
                  Upload
                </Button>
              </div>
              <Divider className="mt-2" />
              <div>
                <div className="flex flex-col md:flex-row items-center md:justify-between md:items-start mt-3">
                  <div>
                    The Recommended size for the Banner is 1528 x 380 Pixels
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <StorefrontOutlinedIcon /> Company Logo
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc]  text-white"
                  onClick={handleClickOpen2}
                >
                  Upload
                </Button>
              </div>
              <Divider className="mt-2" />
              <div>
                <div className="flex flex-col md:flex-row items-center md:justify-between md:items-start mt-3">
                  <div>
                    The Recommended size for the company Logo is 288 x 72 Pixels
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <CropFreeOutlinedIcon /> Payment Image
                </div>
                <div>
                  <input
                    accept="image/*"
                    id="contained-button-file"
                    type="file"
                    onChange={async (e) => {
                      if (e.target.files) {
                        if (globalContext.owner[0].PAYMENTIMG) {
                          deleteImage(globalContext.owner[0].PAYMENTIMG);
                        }
                        setIsUploading({
                          ...isUploading,
                          isPaymentImgUploading: true,
                        });
                        const imagesUrl = await uploadImage(e.target.files);
                        Instance.put("/owner", {
                          type: "paymentImg",
                          data: imagesUrl[0],
                          mobileNo: params.mobileNo,
                        })
                          .then((res) => {
                            if (res.status == 200) {
                              globalContext.owner[0].PAYMENTIMG = imagesUrl[0];
                              dispatch({
                                payload: globalContext.owner,
                                type: INIT_OWNER,
                              });
                              setIsUploading({
                                ...isUploading,
                                isPaymentImgUploading: false,
                              });
                            }
                          })
                          .catch(() => {
                            dispatch({
                              type: SHOW_SNACKBAR,
                              payload: {
                                message: "Something Went Wrong",
                                type: "error",
                              },
                            });
                          });
                      }
                    }}
                    style={{
                      display: "none",
                    }}
                  />
                  {isUploading.isPaymentImgUploading ? (
                    <CircularProgress size={30} className="mt-2" />
                  ) : (
                    <label htmlFor="contained-button-file">
                      <Button
                        variant="contained"
                        component="span"
                        disableElevation
                        className="bg-[#3333cc] text-white"
                      >
                        Upload
                      </Button>
                    </label>
                  )}
                </div>
              </div>
              <Divider className="mt-2" />
              <div>
                <div className="flex flex-col md:flex-row items-center md:justify-between md:items-start mt-3">
                  <div>
                    <div>Upload the ScreenShot of QR Code of the Upi.</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <BurstModeOutlinedIcon /> Bulk Upload Images
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc]  text-white"
                  onClick={handleClickOpen1}
                >
                  Upload
                </Button>
              </div>
              <Divider className="mt-2" />
              <div>
                <div className="flex flex-col md:flex-row items-center md:justify-between md:items-start mt-3">
                  <div>
                    <div>
                      <span className="font-bold">Instructions:</span> Select
                      all the images which you want to upload.The name of the
                      images should be in following format ITMS_1_I0000001.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <FacebookIcon /> Social Links
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc]  text-white"
                  onClick={handleSocialLinkSubmit}
                  disabled={isUploading.isSocialLinkLoading}
                >
                  {isUploading.isSocialLinkLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
              <Divider className="mt-2" />
              <div className="grid md:grid-cols-4 grid-cols-1 gap-4">
                <div className="mt-2">
                  <div className="font-semibold">Facebook Link:</div>
                  <Input
                    className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                    disableUnderline
                    value={socialLink.FBLINK}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setSocialLink({ ...socialLink, FBLINK: null });
                      } else {
                        setSocialLink({
                          ...socialLink,
                          FBLINK: e.target.value,
                        });
                      }
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <FacebookIcon className="text-blue-500" />
                      </InputAdornment>
                    }
                  />
                </div>
                <div className="mt-2">
                  <div className="font-semibold">Youtube Link:</div>
                  <Input
                    className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                    disableUnderline
                    value={socialLink.YTLINK}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setSocialLink({ ...socialLink, YTLINK: null });
                      } else {
                        setSocialLink({
                          ...socialLink,
                          YTLINK: e.target.value,
                        });
                      }
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <YouTubeIcon className="text-red-600" />
                      </InputAdornment>
                    }
                  />
                </div>
                <div className="mt-2">
                  <div className="font-semibold">WhatsApp Number:</div>
                  <Input
                    className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                    disableUnderline
                    value={socialLink.WHANO}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setSocialLink({ ...socialLink, WHANO: null });
                      } else {
                        setSocialLink({ ...socialLink, WHANO: e.target.value });
                      }
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <WhatsAppIcon className="text-green-500" />
                      </InputAdornment>
                    }
                  />
                </div>
                <div className="my-2">
                  <div className="font-semibold">Instagram Link:</div>
                  <Input
                    className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                    disableUnderline
                    value={socialLink.IGLINK}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setSocialLink({ ...socialLink, IGLINK: null });
                      } else {
                        setSocialLink({
                          ...socialLink,
                          IGLINK: e.target.value,
                        });
                      }
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <InstagramIcon className="text-pink-600" />
                      </InputAdornment>
                    }
                  />
                </div>
              </div>
            </div>
            {window.innerWidth < 600 ? (
              <div className="bg-white shadow-sm rounded p-3 mt-4">
                <div className="flex justify-between">
                  <div className="font-bold text-xl">
                    <StorefrontIcon /> Add Shop
                  </div>
                </div>
                <Divider className="mt-2" />
                <div>
                  <div className="flex flex-col md:flex-row items-center md:justify-between md:items-start mt-3">
                    <Typography className="px-4 pt-1">
                      <Link to={`/${params.mobileNo}/addshop`}>Add Shop</Link>
                    </Typography>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <ShareIcon /> Share
                </div>
                <Button
                  variant="outlined"
                  className=" bg-[#3333cc] text-white"
                  onClick={() => {
                    if (window.innerWidth < 600) {
                      history.push(
                        `/${params.mobileNo}/owner/utility?link=${globalContext.owner[0].APPLINK}&type=share`,
                      );
                    } else {
                      navigator.share({
                        url:
                          globalContext.owner && globalContext.owner[0]
                            ? globalContext.owner[0].APPLINK
                              ? globalContext.owner[0].APPLINK
                              : ""
                            : "",
                        title: globalContext.company
                          ? globalContext.company.length != 0
                            ? globalContext.company[0].COMP_NAME
                            : ""
                          : "",
                      });
                    }
                  }}
                >
                  Share
                </Button>
              </div>
              {/* <Divider className="mt-2" />
              <div>
                <div className="flex flex-col md:flex-row items-center md:justify-between md:items-start mt-3">
                  <Typography className="px-4 pt-2 pb-1">
                    <QRCode
                      value={
                        globalContext.owner && globalContext.owner[0]
                          ? globalContext.owner[0].APPLINK
                            ? globalContext.owner[0].APPLINK
                            : ""
                          : ""
                      }
                      includeMargin
                      size={200}
                    />
                  </Typography>
                </div>
              </div> */}
            </div>
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <div className="bg-white shadow-sm rounded p-3">
              <div className="flex justify-between">
                <div className="font-bold text-xl mb-1">
                  <ColorLensOutlinedIcon /> Update Theme
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc] text-white"
                  onClick={handleThemeSubmit}
                >
                  {isUploading.isThemeLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>

              <Divider className="mt-2" />
              <div>
                <div className="flex justify-between mt-3">
                  <div>Primary Color :</div>
                  <input
                    type="color"
                    value={theme.primaryColor}
                    onChange={(e) => {
                      setTheme({ ...theme, primaryColor: e.target.value });
                    }}
                  />
                </div>
                <div className="flex justify-between mt-3">
                  <div>Primary Color Text :</div>
                  <input
                    type="color"
                    value={theme.primaryColorText}
                    onChange={(e) => {
                      setTheme({
                        ...theme,
                        primaryColorText: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="flex justify-between mt-3">
                  <div>Secondary Color :</div>
                  <input
                    type="color"
                    value={theme.secondaryColor}
                    onChange={(e) => {
                      setTheme({ ...theme, secondaryColor: e.target.value });
                    }}
                  />
                </div>
                <div className="flex justify-between mt-3">
                  <div>Secondary Color Text :</div>
                  <input
                    type="color"
                    value={theme.secondaryColorText}
                    onChange={(e) => {
                      setTheme({
                        ...theme,
                        secondaryColorText: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <SettingsOutlinedIcon /> Update Settings
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc] text-white"
                  onClick={handleSettingsSubmit}
                >
                  {isUploading.isSettingsLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
              <Divider className="mt-2" />
              <div>
                <div className="flex justify-between mt-3">
                  <div className="flex items-center">
                    <div>Party Wise Rate</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "prtyRate",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "prtyRate",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "prtyRate")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "prtyRate"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "prtyRate"),
                            );
                          }
                        }}
                        name="PartyWiseRate"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Item Discount</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "itemDisc",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "itemDisc",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "itemDisc")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "itemDisc"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "itemDisc"),
                            );
                          }
                        }}
                        name="ItemDiscount"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Guest Login</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "guestLogin",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "guestLogin",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "guestLogin")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "guestLogin"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "guestLogin"),
                            );
                          }
                        }}
                        name="GuestLogin"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Show Guest Rate</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "guestRate",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "guestRate",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "guestRate")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "guestRate"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "guestRate"),
                            );
                          }
                        }}
                        name="ShowGuestRate"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Show Stock</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "showStk",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "showStk",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "showStk")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "showStk"]);
                          } else {
                            setSettings(settings.filter((e) => e != "showStk"));
                          }
                        }}
                        name="ShowStk"
                      />
                    }
                  />
                </div>
                {settings.find((e) => e == "showStk") ? (
                  <div className="flex justify-between">
                    <div className="flex items-center">
                      <div>Party Wise Stock</div>
                      <Tooltip
                        title={
                          globalContext.settings.length != 0
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "prtyStk",
                              )
                              ? globalContext.settings.find(
                                  (e) => e.VARIABLE == "prtyStk",
                                ).DESCRI
                              : ""
                            : ""
                        }
                        arrow
                        placement="right"
                      >
                        <InfoOutlinedIcon fontSize="small" className="ml-2" />
                      </Tooltip>
                    </div>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={
                            settings.length != 0
                              ? settings.find((e) => e == "prtyStk")
                                ? true
                                : false
                              : false
                          }
                          onChange={(e, newValue) => {
                            if (newValue) {
                              setSettings([...settings, "prtyStk"]);
                            } else {
                              setSettings(
                                settings.filter((e) => e != "prtyStk"),
                              );
                            }
                          }}
                          name="ShowPartyWiseStock"
                        />
                      }
                    />
                  </div>
                ) : null}
                {/* <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Check Stock</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "checkStk"
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "checkStk"
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "checkStk")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "checkStk"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "checkStk")
                            );
                          }
                        }}
                        name="CheckStk"
                      />
                    }
                  />
                </div> */}
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Show Product Without Img</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "showPrdWithoutImg",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "showPrdWithoutImg",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "showPrdWithoutImg")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "showPrdWithoutImg"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "showPrdWithoutImg"),
                            );
                          }
                        }}
                        name="showPrdWithoutImg"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Show Only Products</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "showOnlyProducts",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "showOnlyProducts",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "showOnlyProducts")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "showOnlyProducts"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "showOnlyProducts"),
                            );
                          }
                        }}
                        name="showOnlyProducts"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Show Sign Up</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "showSignUp",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "showSignUp",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "showSignUp")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "showSignUp"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "showSignUp"),
                            );
                          }
                        }}
                        name="showSignUp"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Personal App</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "personalApp",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "personalApp",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "personalApp")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "personalApp"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "personalApp"),
                            );
                          }
                        }}
                        name="personalApp"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Custom Order Label</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "customOrderLabel",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "customOrderLabel",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "customOrderLabel")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "customOrderLabel"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "customOrderLabel"),
                            );
                          }
                        }}
                        name="customOrderLabel"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Sync Sman</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "syncSman",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "syncSman",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "syncSman")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "syncSman"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "syncSman"),
                            );
                          }
                        }}
                        name="syncSman"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Delete Account</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "deleteAccount",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "deleteAccount",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "deleteAccount")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "deleteAccount"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "deleteAccount"),
                            );
                          }
                        }}
                        name="deleteAccount"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Enable UOM</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "enableUom",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "enableUom",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "enableUom")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "enableUom"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "enableUom"),
                            );
                          }
                        }}
                        name="enableUom"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Prol</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "prol",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "prol",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "prol")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "prol"]);
                          } else {
                            setSettings(settings.filter((e) => e != "prol"));
                          }
                        }}
                        name="prol"
                      />
                    }
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Lock New User</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "lockNewUser",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "lockNewUser",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "lockNewUser")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "lockNewUser"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "lockNewUser"),
                            );
                          }
                        }}
                        name="lockNewUser"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Advance Payment Field</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "advancePaymentField",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "advancePaymentField",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "advancePaymentField")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "advancePaymentField"]);
                          } else {
                            setSettings(
                              settings.filter(
                                (e) => e != "advancePaymentField",
                              ),
                            );
                          }
                        }}
                        name="advancePaymentField"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Remarks 1 Field</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "checkoutRemarks1",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "checkoutRemarks1",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "checkoutRemarks1")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "checkoutRemarks1"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "checkoutRemarks1"),
                            );
                          }
                        }}
                        name="checkoutRemarks1"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Remarks 2 Field</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "checkoutRemarks2",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "checkoutRemarks2",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "checkoutRemarks2")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "checkoutRemarks2"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "checkoutRemarks2"),
                            );
                          }
                        }}
                        name="checkoutRemarks2"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Remarks 3 Field</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "checkoutRemarks3",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "checkoutRemarks3",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "checkoutRemarks3")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "checkoutRemarks3"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "checkoutRemarks3"),
                            );
                          }
                        }}
                        name="checkoutRemarks3"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Approval Required</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "approvalRequired",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "approvalRequired",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "approvalRequired")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "approvalRequired"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "approvalRequired"),
                            );
                          }
                        }}
                        name="approvalRequired"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Salesman Location Required</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "smanMandateLocation",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "smanMandateLocation",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "smanMandateLocation")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "smanMandateLocation"]);
                          } else {
                            setSettings(
                              settings.filter(
                                (e) => e != "smanMandateLocation",
                              ),
                            );
                          }
                        }}
                        name="smanMandateLocation"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Wrl Setting</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "wrlSetting",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "wrlSetting",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "wrlSetting")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "wrlSetting"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "wrlSetting"),
                            );
                          }
                        }}
                        name="wrlSetting"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Custom Address Setting</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "customAddress",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "customAddress",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "customAddress")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "customAddress"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "customAddress"),
                            );
                          }
                        }}
                        name="customAddress"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Hide Zero Closing Stk Setting</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "hideZeroStkItem",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "hideZeroStkItem",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "hideZeroStkItem")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "hideZeroStkItem"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "hideZeroStkItem"),
                            );
                          }
                        }}
                        name="hideZeroStkItem"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Check Or Stk Setting</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "checkOrStk",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "checkOrStk",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "checkOrStk")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "checkOrStk"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "checkOrStk"),
                            );
                          }
                        }}
                        name="checkOrStk"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Login With OTP in Hub360 Setting</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "loginWithOtphub360",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "loginWithOtphub360",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "loginWithOtphub360")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "loginWithOtphub360"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "loginWithOtphub360"),
                            );
                          }
                        }}
                        name="loginWithOtphub360"
                      />
                    }
                  />
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center">
                    <div>Shop Availability Setting</div>
                    <Tooltip
                      title={
                        globalContext.settings.length != 0
                          ? globalContext.settings.find(
                              (e) => e.VARIABLE == "shopClosureEnabled",
                            )
                            ? globalContext.settings.find(
                                (e) => e.VARIABLE == "shopClosureEnabled",
                              ).DESCRI
                            : ""
                          : ""
                      }
                      arrow
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" className="ml-2" />
                    </Tooltip>
                  </div>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={
                          settings.length != 0
                            ? settings.find((e) => e == "shopClosureEnabled")
                              ? true
                              : false
                            : false
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSettings([...settings, "shopClosureEnabled"]);
                          } else {
                            setSettings(
                              settings.filter((e) => e != "shopClosureEnabled"),
                            );
                          }
                        }}
                        name="shopClosureEnabled"
                      />
                    }
                  />
                </div>
              </div>
            </div>
            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <SettingsOutlinedIcon /> Update Config Settings
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc] text-white"
                  onClick={handleConfigSettingsBtn}
                >
                  {isUploading.isConfigSettingsLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
              <Divider className="mt-2" />
              <div>
                <div className="grid md:grid-cols-4 grid-cols-1 gap-3">
                  <div className="mt-2">
                    <div className="font-semibold">Order No:</div>
                    <Input
                      className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                      disableUnderline
                      value={configSettings.orderNo}
                      onChange={(e) => {
                        setConfigSettings({
                          ...configSettings,
                          orderNo: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Party Grade:</div>
                    <Input
                      className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                      disableUnderline
                      value={configSettings.partyGd}
                      onChange={(e) => {
                        setConfigSettings({
                          ...configSettings,
                          partyGd: e.target.value.toUpperCase(),
                        });
                      }}
                      inputProps={{ maxLength: 1 }}
                    />
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Salesman Grade:</div>
                    <Input
                      className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                      disableUnderline
                      value={configSettings.salesmanGd}
                      onChange={(e) => {
                        setConfigSettings({
                          ...configSettings,
                          salesmanGd: e.target.value.toUpperCase(),
                        });
                      }}
                      inputProps={{ maxLength: 1 }}
                    />
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Auth Token Time:</div>
                    <Input
                      className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                      disableUnderline
                      value={configSettings.authTTL}
                      onChange={(e) => {
                        setConfigSettings({
                          ...configSettings,
                          authTTL: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Max Product Images:</div>
                    <Input
                      className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                      disableUnderline
                      type="number"
                      value={configSettings.maxImages}
                      onChange={(e) => {
                        setConfigSettings({
                          ...configSettings,
                          maxImages: e.target.value,
                        });
                      }}
                      inputProps={{ min: 1 }}
                    />
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Max Product Videos:</div>
                    <Input
                      className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                      disableUnderline
                      type="number"
                      value={configSettings.maxVideos}
                      onChange={(e) => {
                        setConfigSettings({
                          ...configSettings,
                          maxVideos: e.target.value,
                        });
                      }}
                      inputProps={{ min: 0 }}
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      Set to 0 to disable video uploads
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Signup Fields Configuration */}
            <div className="bg-white shadow-sm rounded p-3 mt-4">
              <div className="flex justify-between">
                <div className="font-bold text-xl">
                  <SettingsOutlinedIcon /> Signup Fields
                </div>
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc] text-white"
                  onClick={handleLabelsSubmit}
                >
                  {isUploading.isUpdateLabelsLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
              <Divider className="mt-2" />
              <div className="mt-2 overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="text-left border-b">
                      <th className="pb-2 pr-4">Field</th>
                      <th className="pb-2 pr-4">Custom Label</th>
                      <th className="pb-2 pr-4">Visible</th>
                      <th className="pb-2">Required</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { key: "signupName", name: "Name" },
                      { key: "signupCompanyName", name: "Company Name" },
                      { key: "signupPassword", name: "Password" },
                      { key: "signupPhone", name: "Phone Number" },
                      { key: "signupPan", name: "PAN" },
                      { key: "signupGst", name: "GST" },
                      { key: "signupAddress1", name: "Address 1" },
                      { key: "signupAddress2", name: "Address 2" },
                      { key: "signupCity", name: "City" },
                      { key: "signupState", name: "State" },
                      { key: "signupDistrict", name: "District" },
                      { key: "signupPincode", name: "Pincode" },
                      { key: "signupEmail", name: "Email" },
                    ].map(({ key, name }) => (
                      <tr key={key} className="border-b last:border-0">
                        <td className="py-2 pr-4 font-medium">{name}</td>
                        <td className="py-2 pr-4">
                          <Input
                            className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg"
                            disableUnderline
                            value={
                              updateLabels[key] ? updateLabels[key].label : ""
                            }
                            onChange={(e) =>
                              setUpdateLabels({
                                ...updateLabels,
                                [key]: {
                                  ...updateLabels[key],
                                  label: e.target.value,
                                },
                              })
                            }
                          />
                        </td>
                        <td className="py-2 pr-4">
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={
                                  updateLabels[key]
                                    ? !!updateLabels[key].isVisible
                                    : false
                                }
                                onChange={(e, newValue) =>
                                  setUpdateLabels({
                                    ...updateLabels,
                                    [key]: {
                                      ...updateLabels[key],
                                      isVisible: newValue,
                                    },
                                  })
                                }
                                name={`${key}_visible`}
                              />
                            }
                          />
                        </td>
                        <td className="py-2">
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={
                                  updateLabels[key]
                                    ? !!updateLabels[key].isRequired
                                    : false
                                }
                                onChange={(e, newValue) =>
                                  setUpdateLabels({
                                    ...updateLabels,
                                    [key]: {
                                      ...updateLabels[key],
                                      isRequired: newValue,
                                    },
                                  })
                                }
                                name={`${key}_required`}
                              />
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {globalContext.settings.find(
              (e) => e.VARIABLE === "advancePaymentField",
            ) ? (
              globalContext.settings.find(
                (e) => e.VARIABLE === "advancePaymentField",
              ).VALUE === "Y" ||
              globalContext.settings.find(
                (e) => e.VARIABLE === "checkoutRemarks1",
              ).VALUE === "Y" ||
              globalContext.settings.find(
                (e) => e.VARIABLE === "checkoutRemarks2",
              ).VALUE === "Y" ||
              globalContext.settings.find(
                (e) => e.VARIABLE === "checkoutRemarks3",
              ).VALUE === "Y" ? (
                <div className="bg-white shadow-sm rounded p-3 mt-4">
                  <div className="flex justify-between">
                    <div className="font-bold text-xl">
                      <SettingsOutlinedIcon /> Update Form Labels
                    </div>
                    <Button
                      variant="contained"
                      disableElevation
                      className="bg-[#3333cc] text-white"
                      onClick={handleLabelsSubmit}
                    >
                      {isUploading.isUpdateLabelsLoading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </div>
                  <Divider className="mt-2" />
                  <div>
                    <div>
                      {globalContext.settings.find(
                        (e) => e.VARIABLE === "advancePaymentField",
                      ).VALUE === "Y" ? (
                        <div className="mt-2">
                          <div className="font-semibold">
                            Advance Payment Text Field:
                          </div>
                          <div className="md:flex">
                            <div>
                              <div>Label:</div>
                              <Input
                                className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                                disableUnderline
                                value={
                                  updateLabels.advancePaymentField
                                    ? updateLabels.advancePaymentField.label
                                    : ""
                                }
                                onChange={(e) => {
                                  setUpdateLabels({
                                    ...updateLabels,
                                    advancePaymentField: {
                                      ...updateLabels.advancePaymentField,
                                      label: e.target.value,
                                    },
                                  });
                                }}
                              />
                            </div>
                            <div className="md:ml-8">
                              <div>Required:</div>
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    checked={
                                      updateLabels.advancePaymentField
                                        ? updateLabels.advancePaymentField
                                            .isRequired
                                        : false
                                    }
                                    onChange={(e, newValue) => {
                                      if (newValue) {
                                        setUpdateLabels({
                                          ...updateLabels,
                                          advancePaymentField: {
                                            ...updateLabels.advancePaymentField,
                                            isRequired: true,
                                          },
                                        });
                                      } else {
                                        setUpdateLabels({
                                          ...updateLabels,
                                          advancePaymentField: {
                                            ...updateLabels.advancePaymentField,
                                            isRequired: false,
                                          },
                                        });
                                      }
                                    }}
                                    name="advancePaymentField"
                                  />
                                }
                              />
                            </div>
                            <div className="md:ml-8">
                              <div>Type:</div>
                              <FormControl className="md:w-52 w-full">
                                <Select
                                  labelId="field-type-label-0"
                                  id="field-type-label-0"
                                  value={
                                    updateLabels.advancePaymentField
                                      ? updateLabels.advancePaymentField.type
                                      : ""
                                  }
                                  onChange={(e) => {
                                    setUpdateLabels({
                                      ...updateLabels,
                                      advancePaymentField: {
                                        ...updateLabels.advancePaymentField,
                                        type: e.target.value,
                                      },
                                    });
                                  }}
                                  input={<Input />}
                                  className="w-72"
                                >
                                  {["Text", "Number"].map((name) => (
                                    <MenuItem
                                      key={name.toLowerCase()}
                                      value={name.toLowerCase()}
                                      className="px-2"
                                    >
                                      <p className="text-xs mb-0">{name}</p>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {globalContext.settings.find(
                        (e) => e.VARIABLE === "checkoutRemarks1",
                      ).VALUE === "Y" ? (
                        <div className="mt-3 md:mt-0">
                          <div className="font-semibold">Remarks 1 Field:</div>
                          <div className="md:flex">
                            <div>
                              <div>Label:</div>
                              <Input
                                className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                                disableUnderline
                                value={
                                  updateLabels.checkoutRemarks1
                                    ? updateLabels.checkoutRemarks1.label
                                    : ""
                                }
                                onChange={(e) => {
                                  setUpdateLabels({
                                    ...updateLabels,
                                    checkoutRemarks1: {
                                      ...updateLabels.checkoutRemarks1,
                                      label: e.target.value,
                                    },
                                  });
                                }}
                              />
                            </div>
                            <div className="md:ml-8">
                              <div>Required:</div>
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    checked={
                                      updateLabels.checkoutRemarks1
                                        ? updateLabels.checkoutRemarks1
                                            .isRequired
                                        : false
                                    }
                                    onChange={(e, newValue) => {
                                      if (newValue) {
                                        setUpdateLabels({
                                          ...updateLabels,
                                          checkoutRemarks1: {
                                            ...updateLabels.checkoutRemarks1,
                                            isRequired: true,
                                          },
                                        });
                                      } else {
                                        setUpdateLabels({
                                          ...updateLabels,
                                          checkoutRemarks1: {
                                            ...updateLabels.checkoutRemarks1,
                                            isRequired: false,
                                          },
                                        });
                                      }
                                    }}
                                    name="checkoutRemarks1"
                                  />
                                }
                              />
                            </div>
                            <div className="md:ml-8">
                              <div>Type:</div>
                              <FormControl className="md:w-52 w-full">
                                <Select
                                  labelId="field-type-label-1"
                                  id="field-type-label-1"
                                  value={
                                    updateLabels.checkoutRemarks1
                                      ? updateLabels.checkoutRemarks1.type
                                      : ""
                                  }
                                  onChange={(e) => {
                                    setUpdateLabels({
                                      ...updateLabels,
                                      checkoutRemarks1: {
                                        ...updateLabels.checkoutRemarks1,
                                        type: e.target.value,
                                      },
                                    });
                                  }}
                                  input={<Input />}
                                  className="w-72"
                                >
                                  {["Text", "Number"].map((name) => (
                                    <MenuItem
                                      key={name.toLowerCase()}
                                      value={name.toLowerCase()}
                                      className="px-2"
                                    >
                                      <p className="text-xs mb-0">{name}</p>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {globalContext.settings.find(
                        (e) => e.VARIABLE === "checkoutRemarks2",
                      ).VALUE === "Y" ? (
                        <div className="mt-3 md:mt-0">
                          <div className="font-semibold">Remarks 2 Field:</div>
                          <div className="md:flex">
                            <div>
                              <div>Label:</div>
                              <Input
                                className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                                disableUnderline
                                value={
                                  updateLabels.checkoutRemarks2
                                    ? updateLabels.checkoutRemarks2.label
                                    : ""
                                }
                                onChange={(e) => {
                                  setUpdateLabels({
                                    ...updateLabels,
                                    checkoutRemarks2: {
                                      ...updateLabels.checkoutRemarks2,
                                      label: e.target.value,
                                    },
                                  });
                                }}
                              />
                            </div>
                            <div className="md:ml-8">
                              <div>Required:</div>
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    checked={
                                      updateLabels.checkoutRemarks2
                                        ? updateLabels.checkoutRemarks2
                                            .isRequired
                                        : false
                                    }
                                    onChange={(e, newValue) => {
                                      if (newValue) {
                                        setUpdateLabels({
                                          ...updateLabels,
                                          checkoutRemarks2: {
                                            ...updateLabels.checkoutRemarks2,
                                            isRequired: true,
                                          },
                                        });
                                      } else {
                                        setUpdateLabels({
                                          ...updateLabels,
                                          checkoutRemarks2: {
                                            ...updateLabels.checkoutRemarks2,
                                            isRequired: false,
                                          },
                                        });
                                      }
                                    }}
                                    name="checkoutRemarks2"
                                  />
                                }
                              />
                            </div>
                            <div className="md:ml-8">
                              <div>Type:</div>
                              <FormControl className="md:w-52 w-full">
                                <Select
                                  labelId="field-type-label-3"
                                  id="field-type-label-3"
                                  value={
                                    updateLabels.checkoutRemarks2
                                      ? updateLabels.checkoutRemarks2.type
                                      : ""
                                  }
                                  onChange={(e) => {
                                    setUpdateLabels({
                                      ...updateLabels,
                                      checkoutRemarks2: {
                                        ...updateLabels.checkoutRemarks2,
                                        type: e.target.value,
                                      },
                                    });
                                  }}
                                  input={<Input />}
                                  className="w-72"
                                >
                                  {["Text", "Number"].map((name) => (
                                    <MenuItem
                                      key={name.toLowerCase()}
                                      value={name.toLowerCase()}
                                      className="px-2"
                                    >
                                      <p className="text-xs mb-0">{name}</p>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {globalContext.settings.find(
                        (e) => e.VARIABLE === "checkoutRemarks3",
                      ).VALUE === "Y" ? (
                        <div className="mt-3 md:mt-0">
                          <div className="font-semibold">Remarks 3 Field:</div>
                          <div className="md:flex">
                            <div>
                              <div>Label:</div>
                              <Input
                                className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg w-full"
                                disableUnderline
                                value={
                                  updateLabels.checkoutRemarks3
                                    ? updateLabels.checkoutRemarks3.label
                                    : ""
                                }
                                onChange={(e) => {
                                  setUpdateLabels({
                                    ...updateLabels,
                                    checkoutRemarks3: {
                                      ...updateLabels.checkoutRemarks3,
                                      label: e.target.value,
                                    },
                                  });
                                }}
                              />
                            </div>
                            <div className="md:ml-8">
                              <div>Required:</div>
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    checked={
                                      updateLabels.checkoutRemarks3
                                        ? updateLabels.checkoutRemarks3
                                            .isRequired
                                        : ""
                                    }
                                    onChange={(e, newValue) => {
                                      if (newValue) {
                                        setUpdateLabels({
                                          ...updateLabels,
                                          checkoutRemarks3: {
                                            ...updateLabels.checkoutRemarks3,
                                            isRequired: true,
                                          },
                                        });
                                      } else {
                                        setUpdateLabels({
                                          ...updateLabels,
                                          checkoutRemarks3: {
                                            ...updateLabels.checkoutRemarks3,
                                            isRequired: false,
                                          },
                                        });
                                      }
                                    }}
                                    name="checkoutRemarks3"
                                  />
                                }
                              />
                            </div>
                            <div className="md:ml-8">
                              <div>Type:</div>
                              <FormControl className="md:w-52 w-full">
                                <Select
                                  labelId="field-type-label-4"
                                  id="field-type-label-4"
                                  value={
                                    updateLabels.checkoutRemarks3
                                      ? updateLabels.checkoutRemarks3.type
                                      : ""
                                  }
                                  onChange={(e) => {
                                    setUpdateLabels({
                                      ...updateLabels,
                                      checkoutRemarks3: {
                                        ...updateLabels.checkoutRemarks3,
                                        type: e.target.value,
                                      },
                                    });
                                  }}
                                  input={<Input />}
                                  className="w-72"
                                >
                                  {["Text", "Number"].map((name) => (
                                    <MenuItem
                                      key={name.toLowerCase()}
                                      value={name.toLowerCase()}
                                      className="px-2"
                                    >
                                      <p className="text-xs mb-0">{name}</p>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null
            ) : null}
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <HomeLayoutManager params={params} />
          </TabPanel>

          {isShopClosureEnabled && (
            <TabPanel value={tabValue} index={3}>
              <ShopClosure embedded />
            </TabPanel>
          )}
        </div>
      </OwnerHeader>
    </div>
  );
};

export default OwnerUtility;

const UploadForm = ({
  open,
  handleClose,
  setImageError,
  localImg,
  setIsUploading,
  isUploading,
  setLocalImg,
  uploadImage,
  imageError,
  deleteImage,
  params,
  globalContext,
  dispatch,
}) => {
  const moveImage = (fromIndex, toIndex) => {
    const updated = [...localImg];
    const [moved] = updated.splice(fromIndex, 1);
    updated.splice(toIndex, 0, moved);
    setLocalImg(updated);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="sm">
        <DialogTitle>
          <div className="flex justify-between items-center">
            <p className="text-lg font-semibold">Banner Images</p>
            <label htmlFor="contained-button-file3">
              <input
                accept="image/*"
                id="contained-button-file3"
                multiple
                type="file"
                style={{
                  display: "none",
                }}
                onChange={async (e) => {
                  setImageError(false);
                  const total = e.target.files.length + localImg.length;
                  if (total <= 10) {
                    setIsUploading({
                      ...isUploading,
                      isBannerUploading: true,
                    });
                    const imgUrls = await uploadImage(
                      e.target.files,
                      1920,
                      900,
                    );
                    setLocalImg(localImg.concat(imgUrls));
                    setIsUploading({
                      ...isUploading,
                      isBannerUploading: false,
                    });
                  } else {
                    setImageError(true);
                  }
                }}
              />
              <Button
                variant="contained"
                disableElevation
                className="bg-[#3333cc] text-white"
                component="span"
              >
                Select Image
              </Button>
            </label>
          </div>
          {imageError && (
            <div className="text-sm pt-1 text-red-500">
              You can upload maximum 10 images.
            </div>
          )}
          {localImg && localImg.length > 0 && (
            <div className="text-xs text-gray-500 mt-1">
              {localImg.length}/10 images — hover to reorder or delete
            </div>
          )}
        </DialogTitle>
        <DialogContent>
          {isUploading.isBannerUploading ? (
            <div className="flex flex-col justify-center items-center py-8">
              <CircularProgress size={30} />
              <div className="text-sm text-gray-500 mt-2">Uploading...</div>
            </div>
          ) : localImg && localImg.length > 0 ? (
            <div className="img-grid">
              {localImg.map((im, index) => (
                <div className="img-grid-item" key={im}>
                  <div className="img-order-badge">{index + 1}</div>
                  <img src={imageUrl + "/" + im} alt={`Banner ${index + 1}`} />
                  <div className="img-actions">
                    <button
                      className="img-btn-move"
                      disabled={index === 0}
                      onClick={() => moveImage(index, index - 1)}
                      title="Move left"
                    >
                      ◀
                    </button>
                    <button
                      className="img-btn-delete"
                      onClick={() => {
                        deleteImage(im);
                        setLocalImg(localImg.filter((e) => e != im));
                      }}
                      title="Delete"
                    >
                      ✕
                    </button>
                    <button
                      className="img-btn-move"
                      disabled={index === localImg.length - 1}
                      onClick={() => moveImage(index, index + 1)}
                      title="Move right"
                    >
                      ▶
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center py-8 text-gray-400">
              <BurstModeOutlinedIcon style={{ fontSize: 48 }} />
              <div className="text-sm mt-2">No banner images added yet</div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="text">
            Close
          </Button>
          <Button
            onClick={() => {
              Instance.put("/owner", {
                type: "banner",
                data: localImg.length == 0 ? null : localImg,
                mobileNo: params.mobileNo,
              })
                .then((res) => {
                  if (res.status == 200) {
                    globalContext.owner[0].BANNER = localImg;
                    dispatch({
                      payload: globalContext.owner,
                      type: INIT_OWNER,
                    });
                    handleClose();
                  }
                })
                .catch(() => {
                  dispatch({
                    type: SHOW_SNACKBAR,
                    payload: {
                      message: "Something Went Wrong",
                      type: "error",
                    },
                  });
                });
            }}
            variant="text"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const BulkUploadForm = ({
  open1,
  setIsUploading,
  isUploading,
  handleBulkUpload,
  handleClose1,
  bulkImgCompleted,
}) => {
  return (
    <div>
      <Dialog open={open1} fullWidth={true} maxWidth="sm">
        <DialogTitle>
          <div className="flex justify-between">
            <p>Bulk Upload Images</p>
            <label htmlFor="contained-button-file4">
              <input
                accept="image/*"
                id="contained-button-file4"
                multiple
                type="file"
                style={{
                  display: "none",
                }}
                onChange={async (e) => {
                  setIsUploading({
                    ...isUploading,
                    isBulkUploading: true,
                  });
                  handleBulkUpload(e.target.files);
                }}
              />
              <Button
                variant="contained"
                disableElevation
                className=" bg-[#3333cc] text-white"
                component="span"
              >
                Select Image
              </Button>
            </label>
          </div>
        </DialogTitle>
        <DialogContent className="wrapper">
          {isUploading.isBulkUploading ? (
            <div className="flex justify-center items-center">
              <Typography variant="body2">
                Current items images uploading: {bulkImgCompleted}
              </Typography>
            </div>
          ) : (
            "Please Select Images to Upload"
          )}
        </DialogContent>
        <DialogActions>
          {!isUploading.isBulkUploading ? (
            <Button onClick={handleClose1} variant="text">
              Close
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
    </div>
  );
};

const SECTION_TYPE_LABELS = {
  deptSection: "Categories",
  itemDisc: "Discounted Products",
  maxSelling: "Most Sold Products",
  deptSelling: "Department Products",
};

const HomeLayoutManager = ({ params }) => {
  const { dispatch } = useContext(GlobalContext);
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const fetchSections = () => {
    setIsLoading(true);
    Instance.get(`/design?mobileNo=${params.mobileNo}`)
      .then((res) => {
        setSections(res.data.result);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { message: "Failed to load layout", type: "error" },
        });
      });
  };

  useEffect(() => {
    fetchSections();
  }, []);

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const fromIndex = result.source.index;
    const toIndex = result.destination.index;
    if (fromIndex === toIndex) return;
    setSections((prev) => {
      const updated = Array.from(prev);
      const [moved] = updated.splice(fromIndex, 1);
      updated.splice(toIndex, 0, moved);
      return updated.map((s, i) => ({ ...s, ORDER_NO: i + 1 }));
    });
  };

  const handleSave = () => {
    setIsSaving(true);
    const payload = sections.map((s) => ({
      dId: s.dId,
      ORDER_NO: s.ORDER_NO,
      TITLE: s.TITLE,
    }));
    Instance.put("/design/reorder", { sections: payload })
      .then(() => {
        setIsSaving(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { message: "Layout saved successfully", type: "success" },
        });
      })
      .catch(() => {
        setIsSaving(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { message: "Failed to save layout", type: "error" },
        });
      });
  };

  const handleDelete = (dId) => {
    Instance.delete(`/design/${dId}`)
      .then(() => {
        setSections((prev) =>
          prev
            .filter((s) => s.dId !== dId)
            .map((s, i) => ({ ...s, ORDER_NO: i + 1 })),
        );
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { message: "Section removed", type: "success" },
        });
      })
      .catch(() => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { message: "Failed to remove section", type: "error" },
        });
      });
  };

  const [departments, setDepartments] = useState([]);
  const [loadingDepts, setLoadingDepts] = useState(false);

  const hasSection = (type) =>
    sections.some((s) => s.DESIGN_NAME_VARIABLE === type);
  const hasDeptSelling = (deptCode) =>
    sections.some((s) => s.DESIGN_NAME === `Dept_${deptCode}`);

  const fetchDepartments = () => {
    if (departments.length > 0) return;
    setLoadingDepts(true);
    Instance.get(`/dept?mobileNo=${params.mobileNo}&per_page=999&page=0`)
      .then((res) => {
        setDepartments(res.data.result || []);
        setLoadingDepts(false);
      })
      .catch(() => setLoadingDepts(false));
  };

  const handleAddSection = (type, deptCode, deptName) => {
    const payload = {
      designNameVariable: type,
      orderNo: sections.length + 1,
      mobileNo: params.mobileNo,
    };
    if (type === "deptSelling") {
      payload.deptCode = deptCode;
      payload.deptName = deptName;
    }
    Instance.post("/design", payload)
      .then((res) => {
        setSections((prev) => [...prev, res.data.result]);
        setAddDialogOpen(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { message: "Section added", type: "success" },
        });
      })
      .catch((err) => {
        const msg = err.response?.data?.message || "Failed to add section";
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { message: msg, type: "error" },
        });
      });
  };

  const startEdit = (s) => {
    setEditingId(s.dId);
    setEditTitle(s.TITLE);
  };

  const saveEdit = (dId) => {
    setSections((prev) =>
      prev.map((s) => (s.dId === dId ? { ...s, TITLE: editTitle } : s)),
    );
    setEditingId(null);
  };

  if (isLoading) {
    return (
      <div className="bg-white shadow-sm rounded p-6">
        <div className="flex justify-center items-center py-12">
          <CircularProgress size={30} />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow-sm rounded p-4">
      <div className="flex justify-between items-center mb-4">
        <div>
          <div className="font-bold text-xl">
            <DashboardOutlinedIcon /> Home Layout
          </div>
          <div className="text-xs text-gray-500 mt-1">
            Reorder sections to change how they appear on the mobile app home
            screen
          </div>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outlined"
            disableElevation
            className="border-[#3333cc] text-[#3333cc]"
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => setAddDialogOpen(true)}
          >
            Add Section
          </Button>
          <Button
            variant="contained"
            disableElevation
            className="bg-[#3333cc] text-white"
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? <CircularProgress size={20} color="inherit" /> : "Save"}
          </Button>
        </div>
      </div>

      {sections.length === 0 ? (
        <div className="flex flex-col items-center py-12 text-gray-400">
          <DashboardOutlinedIcon style={{ fontSize: 48 }} />
          <div className="text-sm mt-2">
            No sections configured yet. Add sections to build your home screen.
          </div>
        </div>
      ) : (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="home-layout-sections">
            {(provided) => (
              <div
                className="space-y-2"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {sections.map((s, index) => (
                  <Draggable
                    key={String(s.dId)}
                    draggableId={String(s.dId)}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`flex items-center gap-3 p-3 rounded-lg border ${
                          snapshot.isDragging
                            ? "border-[#3333cc] bg-blue-50 shadow-lg"
                            : "border-gray-200 bg-gray-50 hover:bg-gray-100"
                        } transition-colors`}
                      >
                        <div
                          {...provided.dragHandleProps}
                          className="cursor-grab active:cursor-grabbing"
                        >
                          <DragIndicatorIcon className="text-gray-400" />
                        </div>
                        <div className="bg-[#3333cc] text-white w-7 h-7 rounded-full flex items-center justify-center text-sm font-semibold flex-shrink-0">
                          {index + 1}
                        </div>
                        <div className="flex-1 min-w-0">
                          {editingId === s.dId ? (
                            <div className="flex items-center gap-2">
                              <input
                                className="border border-gray-300 rounded px-2 py-1 text-sm flex-1"
                                value={editTitle}
                                onChange={(e) => setEditTitle(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") saveEdit(s.dId);
                                  if (e.key === "Escape") setEditingId(null);
                                }}
                                autoFocus
                              />
                              <Button
                                size="small"
                                variant="text"
                                onClick={() => saveEdit(s.dId)}
                                className="text-[#3333cc]"
                              >
                                Done
                              </Button>
                            </div>
                          ) : (
                            <div>
                              <div className="font-semibold text-sm truncate">
                                {s.TITLE}
                              </div>
                              <div className="text-xs text-gray-400">
                                {SECTION_TYPE_LABELS[s.DESIGN_NAME_VARIABLE] ||
                                  s.DESIGN_NAME}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="flex items-center gap-1 flex-shrink-0">
                          <Tooltip title="Edit title">
                            <Button
                              size="small"
                              className="min-w-0 p-1"
                              onClick={() => startEdit(s)}
                            >
                              <EditOutlinedIcon fontSize="small" />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Remove section">
                            <Button
                              size="small"
                              className="min-w-0 p-1 text-red-500"
                              onClick={() => handleDelete(s.dId)}
                            >
                              <DeleteOutlineIcon fontSize="small" />
                            </Button>
                          </Tooltip>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}

      <Dialog
        open={addDialogOpen}
        onClose={() => setAddDialogOpen(false)}
        fullWidth
        maxWidth="xs"
        TransitionProps={{ onEnter: fetchDepartments }}
      >
        <DialogTitle>Add Section</DialogTitle>
        <DialogContent>
          <div className="space-y-2 pt-1">
            {[
              {
                type: "itemDisc",
                label: "Flash Sale",
                desc: "Shows discounted products",
              },
              {
                type: "maxSelling",
                label: "Mega Sale",
                desc: "Shows most sold products",
              },
              {
                type: "deptSection",
                label: "Category",
                desc: "Shows category list on home screen",
              },
            ].map((item) => {
              const exists = hasSection(item.type);
              return (
                <div
                  key={item.type}
                  className={`flex items-center justify-between p-3 rounded-lg border ${
                    exists
                      ? "border-gray-100 bg-gray-50 opacity-50"
                      : "border-gray-200 hover:border-[#3333cc] cursor-pointer hover:bg-blue-50"
                  } transition-colors`}
                  onClick={() => !exists && handleAddSection(item.type)}
                >
                  <div>
                    <div className="font-semibold text-sm">{item.label}</div>
                    <div className="text-xs text-gray-400">{item.desc}</div>
                  </div>
                  {exists ? (
                    <div className="text-xs text-gray-400">Already added</div>
                  ) : (
                    <AddCircleOutlineIcon className="text-[#3333cc]" />
                  )}
                </div>
              );
            })}

            <Divider style={{ margin: "12px 0 8px" }} />
            <div className="font-semibold text-sm mb-1">
              Department Products
            </div>
            <div className="text-xs text-gray-400 mb-2">
              Shows products from a specific category
            </div>

            {loadingDepts ? (
              <div className="flex justify-center py-4">
                <CircularProgress size={24} />
              </div>
            ) : departments.length === 0 ? (
              <div className="text-xs text-gray-400 text-center py-4">
                No departments found
              </div>
            ) : (
              <div
                className="space-y-1"
                style={{ maxHeight: 200, overflowY: "auto" }}
              >
                {departments.map((dept) => {
                  const exists = hasDeptSelling(dept.DEPT_CD);
                  return (
                    <div
                      key={dept.DEPT_CD}
                      className={`flex items-center justify-between p-2 rounded-lg border ${
                        exists
                          ? "border-gray-100 bg-gray-50 opacity-50"
                          : "border-gray-200 hover:border-[#3333cc] cursor-pointer hover:bg-blue-50"
                      } transition-colors`}
                      onClick={() =>
                        !exists &&
                        handleAddSection(
                          "deptSelling",
                          dept.DEPT_CD,
                          dept.dept_name,
                        )
                      }
                    >
                      <div className="text-sm">{dept.dept_name}</div>
                      {exists ? (
                        <div className="text-xs text-gray-400">
                          Already added
                        </div>
                      ) : (
                        <AddCircleOutlineIcon
                          fontSize="small"
                          className="text-[#3333cc]"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddDialogOpen(false)} variant="text">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
